import React from "react";
import { Button } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import Spacer from "@components/atoms/Spacer";
import styled from "styled-components/native";
import { useTranslation } from "react-i18next";
import { BottomButtonsProps } from "../types";

export const BottomButtons: React.FC<BottomButtonsProps> = ({
  activeNavigationIndex,
  onboardingDataState,
  toRegisterScreen,
  toLoginScreen,
  buttonCategory,
  buttonType,
  isPostOnboarding,
  skipToAppNavigator,
  goToAppNavigator,
  goToPreviousScreen,
  goToNextScreen,
  isButtonLoading,
  isButtonDisabled,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {activeNavigationIndex < onboardingDataState.length - 1 ? (
        isPostOnboarding ? (
          <OverLayContainer>
            <ButtonContainer>
              <FirstButton>
                <Button
                  category={buttonCategory.default}
                  title={
                    activeNavigationIndex === 0
                      ? t("onboarding.button.skip.text")
                      : t("onboarding.button.previous.text")
                  }
                  type={buttonType.secondary}
                  onPress={
                    activeNavigationIndex === 0
                      ? skipToAppNavigator
                      : goToPreviousScreen
                  }
                />
              </FirstButton>
              <Spacer size={SpaceType.Big} />
              <SecondButton>
                <Button
                  category={buttonCategory.default}
                  title={t("onboarding.button.next.text")}
                  type={buttonType.primary}
                  onPress={goToNextScreen}
                />
              </SecondButton>
            </ButtonContainer>
          </OverLayContainer>
        ) : (
          <Button
            category={buttonCategory.default}
            title={t("onboarding.button.skip.text")}
            type={buttonType.tertiary}
            onPress={isPostOnboarding ? skipToAppNavigator : toRegisterScreen}
          />
        )
      ) : (
        <OverLayContainer>
          <ButtonContainer>
            <SignUpButton>
              <Button
                category={buttonCategory.default}
                title={
                  isPostOnboarding
                    ? t(
                        onboardingDataState.length === 1
                          ? "onboarding.button.skip.text"
                          : "onboarding.button.previous.text"
                      )
                    : t("onboarding.button.signUp.text")
                }
                type={buttonType.secondary}
                onPress={
                  isPostOnboarding
                    ? onboardingDataState.length === 1
                      ? skipToAppNavigator
                      : goToPreviousScreen
                    : toRegisterScreen
                }
              />
            </SignUpButton>
            <Spacer size={SpaceType.Big} />
            <LogInButton>
              <Button
                category={buttonCategory.default}
                title={
                  isPostOnboarding
                    ? t("onboarding.button.gotit.text")
                    : t("onboarding.button.Login.text")
                }
                type={buttonType.primary}
                loading={isPostOnboarding && isButtonLoading}
                disabled={isPostOnboarding && isButtonDisabled}
                onPress={isPostOnboarding ? goToAppNavigator : toLoginScreen}
              />
            </LogInButton>
          </ButtonContainer>
        </OverLayContainer>
      )}
    </>
  );
};

const OverLayContainer = styled.View`
  align-items: center;
`;

const ButtonContainer = styled.View`
  flex-direction: row;
  width: 100%;
  max-width: 343px;
`;

const SignUpButton = styled.View`
  width: 50%;
  flex: 1;
  justify-content: flex-start;
`;

const LogInButton = styled.View`
  width: 50%;
  flex: 1;
  justify-content: flex-start;
`;

const FirstButton = styled.View`
  width: 50%;
  flex: 1;
  justify-content: flex-start;
`;

const SecondButton = styled.View`
  width: 50%;
  flex: 1;
  justify-content: flex-start;
`;
